import { EContractStatus, ECreditApplicationStatus, EDocumentType } from '@if/core/types'
import { CircularProgress, Typography } from '@mui/material'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'
import StepStatusSection from '../../../App/components/StepStatusSection'
import { canPollCreditApp, isServerAnalysingCredit } from '../../credit-hooks'
import { ECreditApplicationStatusMessage, GetFundingIconAndMessage } from '../../viewCreditApp-selectors'
import FundingCreatingLoan from './FundingCreatingLoan'
import FundingLoanCompleted from './FundingLoanCompleted'
import FundingLoanCreated from './FundingLoanCreated'

interface Props {
  creditApp: CreditApplication
}
const FundingTile = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const isAnalysing = isServerAnalysingCredit(creditApp) && canPollCreditApp(creditApp)
  const icon = GetFundingIconAndMessage(creditApp)
  if (
    creditApp.electronicSignatures?.length > 0 ||
    creditApp.requiredDocuments.some((doc) => doc.typeId === EDocumentType.SignedCVT) ||
    creditApp.contract?.status === EContractStatus.Completed
  ) {
    return (
      <StepStatusSection
        title={t('common.funding')}
        iconMessage={icon.iconMessage ? t(`creditApplicationStatus.${icon.iconMessage}`) : null}
        iconType={icon.iconType}
      >
        {isAnalysing ? (
          <div style={{ textAlign: 'center' }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {icon.iconMessage === ECreditApplicationStatusMessage.DocumentsRequired && (
              <Typography variant="body1">{t('viewCreditApplication.requiredDocuments')}</Typography>
            )}
            {icon.iconMessage === ECreditApplicationStatusMessage.ManualRevision && (
              <Typography variant="body1">{t('viewCreditApplication.documentsAwaitingApproval')}</Typography>
            )}
            {icon.iconMessage === ECreditApplicationStatusMessage.Processing && !creditApp.loanCreated && (
              <FundingCreatingLoan id={creditApp.id!} financingProgramId={creditApp.financingProgramId} />
            )}
            {icon.iconMessage === ECreditApplicationStatusMessage.Waiting &&
              creditApp.loanCreated &&
              creditApp.status !== ECreditApplicationStatus.Completed && (
                <FundingLoanCreated
                  activationDate={creditApp.deliveryOn}
                  id={creditApp.id!}
                  financingProgramId={creditApp.financingProgramId}
                />
              )}
            {icon.iconMessage === ECreditApplicationStatusMessage.Completed && (
              <FundingLoanCompleted id={creditApp.id!} financingProgramId={creditApp.financingProgramId} />
            )}
          </>
        )}
      </StepStatusSection>
    )
  }
  return (
    <StepStatusSection title={t('common.funding')}>
      <Typography variant="body1">{t('viewCreditApplication.fundingNotStarted')}</Typography>
    </StepStatusSection>
  )
}

export default FundingTile
